<template>
  <DublettenFilterPanel
    :optionsArray="agenturDuplicatesIdFilterOptions"
    :storeFunction="getAgenturFilterFunction"
    :placeholder="$t('AGENTUREN.AGENTURNUMMER')"
    objectName="Agentur"
    :stateOptions="stateOptions"
    :appliedIds="appliedFilter.idFilter"
    :appliedState="appliedFilter.duplicateState"
    @apply="onApply"
  ></DublettenFilterPanel>
</template>

<script>
import { mapState } from 'vuex';

import {
  GET_AGENTUR_DUPLICATES,
  SET_AGENTUR_DUPLICATES_ID_FILTER,
  GET_AGENTUR_DUPLICATES_ID_FILTER_OPTIONS,
  SET_AGENTUR_DUPLICATES_STATE_FILTER,
  SET_AGENTUR_DUPLICATES_SKIP,
} from '@/core/agenturen/stores/agenturDuplicates.module';
import dublettenConfirmationStateFilter from '@/core/common/dubletten-state-filter.config.json';
import DublettenFilterPanel from '@/components/common/dubletten-filter-panel.vue';

export default {
  components: {
    DublettenFilterPanel,
  },
  computed: {
    stateOptions() {
      return Object.keys(dublettenConfirmationStateFilter).map(key => ({
        text: this.$t(`DUBLETTEN.CONFIRMATION.${key.toUpperCase()}`),
        value: key,
      }));
    },
    ...mapState({
      agenturDuplicatesIdFilterOptions: state => state.agenturDuplicates.agenturIdFilterOptions,
      // Der Store-Filter entspricht dem angewendeten Stand, weil erst onApply schreibt
      appliedFilter: state => state.agenturDuplicates.filter,
    }),
  },
  methods: {
    getAgenturFilterFunction(id) {
      return this.$store.dispatch(GET_AGENTUR_DUPLICATES_ID_FILTER_OPTIONS, { idFilter: id });
    },
    onApply({ ids, state }) {
      this.$store.commit(SET_AGENTUR_DUPLICATES_ID_FILTER, ids);
      // Ohne Auswahl gilt 'all', damit im Store immer ein gültiger Key steht
      this.$store.commit(SET_AGENTUR_DUPLICATES_STATE_FILTER, state || 'all');
      this.$store.commit(SET_AGENTUR_DUPLICATES_SKIP, 0);
      this.$store.dispatch(GET_AGENTUR_DUPLICATES);
      this.$emit('onClickSaveFilter');
    },
  },
};
</script>
